export default __webpack_public_path__ + "static/media/primary-javascript.9901009c.svg";